import React, { Component, PropTypes } from 'react';
import { RadialSVGProgressBar } from 'components/Widgets';
import { DragSource, DropTarget } from 'react-dnd';
import { ItemTypes } from 'Constants';
import { Paper, Styles, RaisedButton, IconButton } from 'material-ui';
import * as Colors from 'components/Material/Styles/Colors';
import * as MaterialIcons from 'components/Material/SvgIcons';
import * as Icons from 'components/Icons';
import Page from './Page';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import TextField from './TextField';
import styles from './styles';
import { CourseActions } from 'actions';
import { history } from 'helpers';
import { findDOMNode } from 'react-dom';
import { ClipboardStore } from 'stores';
import { ClipboardActions } from 'actions';
import { mixin, RefluxMixin } from 'Util';
import { ThemeStore } from 'stores';
import Message from 'services/Message';


const { Spacing } = Styles;

const sectionSource = {
  beginDrag(props) {
    return {
      index: props.index
    };
  }
};

const sectionTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    props.onMoveSection(dragIndex, hoverIndex);

    monitor.getItem().index = hoverIndex;
  }
};

class Section extends mixin(RefluxMixin, Component) {
  static displayName = 'Section';

  static propTypes = {
    collapsed: PropTypes.bool,
    onDeleteSection: PropTypes.func,
    onDeletePage: PropTypes.func,
    onMoveSection: PropTypes.func,
    onMovePageToSection: PropTypes.func,
    data: PropTypes.object,
    style: PropTypes.object,
    locked: PropTypes.bool
  };

  static contextTypes = {
    router: PropTypes.object,
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      name: null,
      mode: this.props.mode || 'detail',
      mouseOver: false,
      controlsExpanded: false
    };
  }

  listenToStores() {
    this.listenToStore(ClipboardStore, 'clipboard');
  }

  gotoPage(params) {
    const { ownerSlug, courseSlug, sectionSlug, pageSlug, pageId } = params;
    history.push(
      `/course/${ownerSlug}/${courseSlug}/${sectionSlug}/${pageSlug}/${pageId}`
    );
  }

  // moveSection(source, target) {
  //   if (this.props.onMoveSection) {
  //     this.props.onMoveSection(source, target);
  //   }
  // }

  scrollIntoView(node) {
    if (this.props.scrollIntoView) {
      this.props.scrollIntoView(node);
    }
  }

  addPage(sectionId) {
    CourseActions.addPage(sectionId, this.context.getIntlMessage('page.new'));
  }

  deleteSection(sectionId) {
    if (this.props.onDeleteSection) {
      this.props.onDeleteSection(sectionId);
    }
  }

  deletePage(pageId) {
    if (this.props.onDeletePage) {
      this.props.onDeletePage(pageId);
    }
  }

  edit() {
    this.setState({ mode: 'edit' });
  }

  trySave() {
    const name = this.refs.textfield.getValue();
    if (name.trim().length !== 0) {
      CourseActions.updateSection({ id: this.props.data.id, name });
      this.setState({ name, mode: 'detail' });
    } else {
      Message.info('Section name cannot be a space!!');
    }
  }

  save() {
    this.setState({ mode: 'detail' });
  }

  getStyle(isActive, opacity = 0.1) {
    const { isDragging, theme } = this.props;
    return Object.assign(
      {},
      styles.section,
      isActive
        ? {
            backgroundColor: ThemeStore.getColor(theme, opacity)
          }
        : null,
      isActive ? styles.activeSectionHeader : styles.inactiveSectionHeader,
      this.props.style,
      isDragging
        ? {
            opacity: 0.5
          }
        : {
            opacity: 1
          }
    );
  }

  getHeaderStyle() {
    return Object.assign(
      {},
      styles.sectionHeader,
      this.state.mouseOver
        ? {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderColor: 'rgba(255, 255, 255, 0.5)'
          }
        : null
    );
  }

  mouseOver(mouseOver = false) {
    const newState = {
      mouseOver
    };
    if (!mouseOver) {
      newState.controlsExpanded = false;
    }
    this.setState(newState);
  }

  expandControls() {
    this.setState({ controlsExpanded: true });
  }

  collapseControls() {
    this.setState({ controlsExpanded: false });
  }

  duplicate() {
    CourseActions.duplicateSection(this.props.courseId, this.props.data.id);
  }

  movePage = (sectionIndex, pageIndex, toSectionIndex, toPageIndex) => {
    CourseActions.movePage(
      this.props.courseId,
      sectionIndex,
      pageIndex,
      toSectionIndex,
      toPageIndex
    );
  }

  copy() {
    ClipboardActions.copy({
      type: 'section',
      id: this.props.id,
      data: this.props.data
    });
  }

  paste() {
    const page = ClipboardStore.paste().data;
    CourseActions.pastePage(this.props.data.id, page);
  }

  addSection(type) {
    if (type === 'quiz') {
      CourseActions.addPage(this.props.data.id, '', this.context.getIntlMessage('page.new'));
    } else {
      CourseActions.addSection(
        this.props.courseId,
        this.props.data.id,
        this.context.getIntlMessage('section.new'),
        this.context.getIntlMessage('page.new')
      );
    }
  }

  render() {
    let pages = null,
      controls,
      name,
      chapterProgress = this.props.data.progress,
      currentPage = this.props.currentPage,
      hasCurrentPage = false,
      progress;
    const {
      data,
      settings,
      isDragging,
      connectDragSource,
      connectDropTarget,
      theme
    } = this.props;
    const iconButtonStyle = {
      backgroundColor: Colors.Colors.fullWhite,
      height: 38,
      width: 38,
      padding: (38 - 24) / 2
    };
    pages = this.props.data.pages.map((page, index) => {
      let params;

      params = {
        ownerSlug: this.props.ownerSlug,
        courseSlug: this.props.courseSlug,
        sectionSlug: this.props.data.slug,
        pageSlug: page.slug,
        pageId: page.id
      };
      hasCurrentPage = hasCurrentPage || page.id === currentPage;
      if (!this.props.editor && (data.isLocked || page.isLocked)) {
        return (
          <Page
            theme={theme}
            pages={this.props.data.pages}
            onMovePage={this.movePage}
            editor={this.props.editor}
            reader={this.props.reader}
            index={index}
            sectionIndex={this.props.index}
            courseId={this.props.courseId}
            scrollIntoView={this.scrollIntoView.bind(this)}
            currentPage={page.id === currentPage}
            style={{ ...this.props.style, cursor: 'default', color: '#abaaaa' }}
            key={page.id}
            data={page}
            onDelete={this.deletePage.bind(this)}
            sectionId={this.props.data.id}
            id={page.id}
            progress={page.progress}
            tasks={page.tasks}
            mode={page.mode}
            name={page.name}
          />
        );
      }
      return (
        <Page
          theme={theme}
          pages={this.props.data.pages}
          onMovePage={this.movePage}
          editor={this.props.editor}
          reader={this.props.reader}
          index={index}
          sectionIndex={this.props.index}
          courseId={this.props.courseId}
          scrollIntoView={this.scrollIntoView.bind(this)}
          currentPage={page.id === currentPage}
          style={this.props.style}
          key={page.id}
          data={page}
          onDelete={this.deletePage.bind(this)}
          sectionId={this.props.data.id}
          id={page.id}
          isQuiz={data.type === 'quiz'}
          progress={page.progress}
          tasks={page.tasks}
          mode={page.mode}
          onTouchTap={this.gotoPage.bind(this, params)}
          name={page.name}
        />
      );
    });
    if (data.type === 'quiz') {
      progress = null
    } else if (data.isLocked && !this.props.editor) {
      progress = (
        <MaterialIcons.ActionLock
          color={'rgba(128, 128, 128, 0.5)'}
          style={{
            position: 'absolute',
            right: Spacing.desktopGutterMini * 2,
            top: 0
          }}
        />
      );
    } else if (chapterProgress === 1) {
      progress = (
        <Icons.ChapterDone
          color={ThemeStore.getColor(this.props.theme)}
          style={{
            position: 'absolute',
            right: Spacing.desktopGutterMini * 2,
            top: 0
          }}
        />
      );
    } else {
      progress = (
        <RadialSVGProgressBar
          strokeColor={ThemeStore.getColor(this.props.theme)}
          label={false}
          style={{
            position: 'absolute',
            right: Spacing.desktopGutterMini * 2,
            top: 0
          }}
          size={26}
          amount={chapterProgress * 100}
        />
      );
    }
    if (this.state.mode === 'edit') {
      const extraStyls = data.type === 'quiz' && { color: 'white' }
      const extraUnderlineStyls = data.type === 'quiz' && { borderColor: 'white' }
      name = (
        <TextField
          inputStyle={{...styles.textField, ...extraStyls}}
          underlineFocusStyle={extraUnderlineStyls}
          onEnterKeyDown={this.trySave.bind(this)}
          fullWidth
          ref="textfield"
          defaultValue={this.state.name || this.props.data.name}
        />
      );
      controls = (
        <div
          className="controls"
          style={{
            position: 'absolute',
            transition: 'all 0.3s ease',
            whiteSpace: 'nowrap'
          }}
          key="controls-done"
        >
          <IconButton
            touch
            tooltip={this.context.getIntlMessage('Save')}
            tooltipPosition="bottom-left"
            style={iconButtonStyle}
            onTouchTap={this.trySave.bind(this)}
          >
            <MaterialIcons.ActionVisibility />
          </IconButton>
        </div>
      );
    } else {
      name = (
        <div onTouchTap={this.props.onTouchTap}>
          {this.state.name || this.props.data.name}
          {progress}
        </div>
      );
      if (this.state.mouseOver && this.props.editor) {
        let paste;
        let moreControls;
        const { clipboard } = this.state;
        if (false && clipboard.object && clipboard.object.type === 'page') {
          paste = (
            <IconButton
              style={iconButtonStyle}
              onTouchTap={this.paste.bind(this)}
            >
              <MaterialIcons.ContentContentPaste hoverColor={'#777'} />
            </IconButton>
          );
        }
        if (this.state.controlsExpanded) {
          moreControls = (
            <div>
              {paste}
              {/* <IconButton touch tooltip={this.context.getIntlMessage('Copy')} style={iconButtonStyle} onTouchTap={this.copy.bind(this)}><MaterialIcons.ContentContentCopy hoverColor={'#777'} /></IconButton> */}
              {data.type !== 'quiz' && <IconButton
                style={iconButtonStyle}
                onTouchTap={this.duplicate.bind(this)}
              >
                <MaterialIcons.ImageFilterNone hoverColor={'#777'} />
              </IconButton>}
              <IconButton
                style={iconButtonStyle}
                onTouchTap={this.edit.bind(this)}
              >
                <MaterialIcons.ContentCreate hoverColor={'#777'} />
              </IconButton>
              {data.type !== 'quiz' && <IconButton
                style={iconButtonStyle}
                onTouchTap={this.deleteSection.bind(this, this.props.data.id)}
              >
                <MaterialIcons.ActionDelete hoverColor={'#777'} />
              </IconButton>}
            </div>
          );
        } else {
          moreControls = (
            <div>
              <IconButton
                style={iconButtonStyle}
                onTouchTap={this.expandControls.bind(this)}
              >
                <MaterialIcons.NavigationMoreHoriz hoverColor={'#777'} />
              </IconButton>
              <IconButton
                style={iconButtonStyle}
                onTouchTap={this.addSection.bind(this, data.type)}
              >
                <MaterialIcons.ContentAdd hoverColor={'#777'} />
              </IconButton>
            </div>
          );
        }

        controls = (
          <Paper
            className="controls"
            style={{
              position: 'absolute',
              transition: 'all 0.3s ease',
              whiteSpace: 'nowrap'
            }}
            key="controls"
          >
            {moreControls}
          </Paper>
        );
      }
    }
    let addPageButton;

    if (this.props.editor) {
      addPageButton = (
        <div style={styles.addPageButtonContainer}>
          <RaisedButton
            backgroundColor={'transparent'}
            labelColor={Colors.Colors.fullWhite}
            fullWidth={true}
            style={styles.addPageButton}
            onTouchTap={this.addPage.bind(this, this.props.data.id)}
          >
            <div style={styles.addPageLabel}>
              <MaterialIcons.ContentAdd
                style={{ verticalAlign: 'middle' }}
                color={Colors.Colors.fullWhite}
              />
              {this.context.getIntlMessage('page.new')}
            </div>
          </RaisedButton>
        </div>
      );
    }

    return connectDragSource(
      connectDropTarget(
        <div style={ data.type !== 'quiz' ? this.getStyle(hasCurrentPage) : this.getStyle(true, 1)}>
          <div
            style={data.type !== 'quiz' ? this.getHeaderStyle() : {...this.getHeaderStyle(), color: 'white'}}
            onMouseEnter={this.mouseOver.bind(this, true)}
            onMouseLeave={this.mouseOver.bind(this, false)}
          >
            {name}
            <CSSTransitionGroup
              transitionName="controls"
              component="div"
              style={{ position: 'absolute', right: 0, top: 0, bottom: 0 }}
              transitionEnterTimeout={300}
              transitionLeaveTimeout={300}
            >
              {controls}
            </CSSTransitionGroup>
          </div>
          {pages}
        </div>
      )
    );
  }
}

export default DropTarget(ItemTypes.TOC_SECTION, sectionTarget, connect => ({
  connectDropTarget: connect.dropTarget()
}))(
  DragSource(ItemTypes.TOC_SECTION, sectionSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    // connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  }))(Section)
);



// WEBPACK FOOTER //
// ./src/js/components/Course/TableOfContents/Section.js